import {Dimension, Pair} from '../abstract-units';
import {CellId} from '../cell';
import {Edge} from '../edge';

export class EdgeActionHistory {

    public edgeAxis: Dimension;
    public sidedCellIds: Pair<CellId[]>;
    public movingAxisPosChange: Pair<number>;

    constructor(
        edge: Edge,
        movingAxisPosChange: Pair<number>
    ) {
        this.edgeAxis = edge.axis;
        this.sidedCellIds = edge.sides.map(cells => cells.map(cell => cell.id)) as Pair<CellId[]>;
        this.movingAxisPosChange = movingAxisPosChange;
    }

}
